import type { PathPattern } from 'react-router-dom';
import { AppRoutePath } from 'config/constants';

// Stable pattern objects: useMatch memoizes on pattern identity, so an inline literal recompiles the route.
export const REPORTER_PREFIX_PATTERN: PathPattern = { path: AppRoutePath.REPORTER, end: false };
export const REPORTER_BLANK_PREFIX_PATTERN: PathPattern = {
  path: AppRoutePath.REPORTER_BLANK,
  end: false,
};
